const getValue = (propertiesToDisplay, getUser) => {
  const [baseProp, nestedProp] = propertiesToDisplay[0].split('.');
  const baseValue = getUser[baseProp];
  const isArray = Array.isArray(baseValue);
  if (nestedProp && baseValue) {
    let nestedValue;
    if (isArray) {
      nestedValue = baseValue.length ? baseValue.map(nested => nested ? nested[nestedProp] : '').join(', ') : '';
    } else {
      nestedValue = baseValue[nestedProp];
    }
    return nestedValue || '';
  }
  return baseValue || '';
};
const checkAndSetProps = (userPropsToDisplay, getUser) => {
  const userDataLayer = {};
  userPropsToDisplay.forEach(prop => {
    const {
      propertiesToDisplay,
      label,
      staticMetric
    } = prop;
    if (staticMetric) {
      userDataLayer[label] = staticMetric;
      return;
    }
    if (!propertiesToDisplay[0]) return;
    const value = getValue(propertiesToDisplay, getUser);
    userDataLayer[label] = value;
  });
  return userDataLayer;
};
const buildUserLayer = (userData, userPropsToDisplay) => {
  if (!userData || !userData.getUser) return {};
  const {
    getUser
  } = userData;
  const userDataLayer = checkAndSetProps(userPropsToDisplay, getUser);
  return {
    user: userDataLayer
  };
};
export default buildUserLayer;
//# sourceMappingURL=build-user-layer.js.map